<app-tab-header>
  <div class="d-flex">
    <div class="d-flex justify-content-between ms-auto">
      @if (userCanFixSchedule) {
        <div class="me-1">
          <button type="button" kendoButton themeColor="primary" [svgIcon]="icons.search" (click)="toggleFindScheduleDialog()"> Find Schedule</button>
          <button type="button" kendoButton themeColor="primary" [svgIcon]="icons.plus" (click)="toggleCreateScheduleDialog()"> Create Schedule</button>
        </div>
      }
      @if (scheduleDataLoaded) {
        <div class="div2">
          <button type="button" kendoButton [buttonLoading]="loading || working" themeColor="primary" [svgIcon]="icons.save" [disabled]="disableSave" (click)="submitPayload()"> Save</button>
          <button type="button" kendoButton themeColor="primary" [svgIcon]="icons.cancel" [disabled]="disableSave" (click)="handleCancelButton()"> Cancel</button>
        </div>
      }
    </div>

  </div>
</app-tab-header>

<div kendoTooltip #tooltip="kendoTooltip" [showOn]="'hover'" filter='tr span' style="height:calc(100% - 60px)">

  <ag-grid-angular #agGridFF class="ag-theme-balham" style="height:100%;min-height:500px;" (gridReady)="onGridReady($event)"
    [gridOptions]="gridOptions.gridOptions"
    [stopEditingWhenCellsLoseFocus]="true"
    (cellValueChanged)="onCellValueChanged($event)">
  </ag-grid-angular>

</div>
<div kendoDialogContainer></div>

@if (displaySaveDialog) {
  <kendo-dialog title="Saving Changes">
    <p style="margin: 30px; text-align: center;">
      Saving changes to the Project Schedule
    </p>
  </kendo-dialog>
}

@if (isFindScheduleDialogVisible) {
  <kendo-dialog title="Find Schedule" [width]="860" (close)="toggleFindScheduleDialog()">
    <app-find-project-schedule [projectId]="projectTab().ProjectId" (closeDialog)="toggleFindScheduleDialog()"></app-find-project-schedule>
  </kendo-dialog>
}

@if (isCreateScheduleDialogVisible) {
  <kendo-dialog title="Create Schedule" [width]="600" (close)="toggleCreateScheduleDialog()">
    <app-create-project-schedule [projectId]="projectTab().ProjectId" (closeDialog)="toggleCreateScheduleDialog()"></app-create-project-schedule>
  </kendo-dialog>
}